import { UnityEvent } from "../model/UnityConstant";

function NavigateToLoginHandler(unityContext, onLogout) {
    unityContext.on(UnityEvent.NavigateToLogin, onLogout);
    return () => unityContext.removeEventListener(UnityEvent.NavigateToLogin);
}

export default NavigateToLoginHandler;